const response = (payload) =>
    payload?.map((item) => ({
        ...item,
        id: item.name,
    }));

export default response;
